import { throttle } from "lodash";
import { getCart, getHeaderHeight } from "../helpers";
import { search as setupSearch } from "./search";
import { dropdownMenuV2 as setupMenu } from "../snippets/dropdown-menu-v2";
import { init as setupCountrySelect } from "./country-select";

export function init(headerContainer) {
  const miniCartButton = headerContainer.querySelector(
    ".header-minicart-button"
  );
  if (miniCartButton instanceof HTMLElement) {
    // setupMiniCartLink(miniCartButton);
    updateMiniCartItemCount(miniCartButton);
  }

  const searchButton = headerContainer.querySelector(".header-search-button");
  if (searchButton instanceof HTMLElement) {
    setupSearch(searchButton);
  }

  const menuToggleButton = headerContainer.querySelector(".menu-toggle-button");
  if (menuToggleButton instanceof HTMLElement) {
    setupMenu(menuToggleButton);
    /* window.addEventListener(
      "resize",
      throttle(() => setupMenu(menuToggleButton), 200)
    ); */
  }
  const headerContainerHeight = getHeaderHeight();

  const dropdownMenuContainer = document.getElementById(
    "dropdown-menu-container-v2"
  );
  const searchContainer = document.getElementById("search-container");

  if (window.innerWidth > 768) {
    const countrySelectTrigger = document.querySelector(
      ".header-currency-button"
    );
    if (countrySelectTrigger instanceof HTMLElement) {
      setupCountrySelect(countrySelectTrigger);
    }
  }

  /* Handle scroll event -- start */
  let prevScroll = window.pageYOffset;

  const toggleHeaderOnScroll = () => {
    // Don't hide the nav if the dropdown menu or search is open
    if (
      isDropdownOpen(searchContainer) ||
      isDropdownOpen(dropdownMenuContainer)
    ) {
      headerContainer.classList.remove("scroll-down", "should-animate");
      return;
    }

    let currentScroll = window.pageYOffset;

    // Start hiding header after we've scrolled past the header
    if (currentScroll > headerContainerHeight) {
      headerContainer.classList.add("scroll-down", "should-animate");
      // If scroll up
      if (currentScroll < prevScroll) {
        headerContainer.classList.add("scroll-up");
        headerContainer.classList.remove("scroll-down");
      } else {
        // If scroll down
        headerContainer.classList.remove("scroll-up");
        headerContainer.classList.add("scroll-down");
      }
    } else {
      headerContainer.classList.remove("scroll-down", "should-animate");
    }
    prevScroll = currentScroll;
  };

  window.addEventListener("scroll", throttle(toggleHeaderOnScroll, 200));
  /* Handle scroll event -- end */
}

/**
 *  @param {HTMLElement} [baseElement]
 */
export async function updateMiniCartItemCount(baseElement) {
  const buttonSuffix = (baseElement || document).querySelector(
    ".header-minicart-item-count"
  );

  if (buttonSuffix instanceof HTMLElement) {
    let cart;
    try {
      cart = await getCart();
    } catch (err) {
      console.error(err);
    }
    if (typeof cart !== "object") return;

    const itemCount = cart["item_count"];

    if (typeof itemCount === "number") {
      buttonSuffix.textContent =
        itemCount === 0 ? "" : "(" + itemCount.toString() + ")";
    }
  }
}

/*
async function setupMiniCartLink(baseElement) {
  baseElement.onclick = (event) => {
    // When javascript is disabled, clicking on the link
    // will take the user to the cart page.
    if (window.innerWidth > 640) {
      event.preventDefault();
      // Otherwise, the mini cart gets shown.
      openMinicart();
    }
  };
  updateMiniCartItemCount(baseElement);
}
*/
/**
 * Tells if the dropdown is open based on height
 * @param {HTMLElement} element
 */
function isDropdownOpen(element) {
  if (!element) return;
  return element.offsetHeight != 0;
}

export function makeHeaderRed() {
  const header = document.querySelector("header");
  header.classList.add("is-red");
}
export function makeHeaderTransparent() {
  const header = document.querySelector("header");
  header.classList.remove("is-red");
}
